import React, { Component } from 'react';
import Radium from 'radium';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Redirect } from 'react-router-dom';

class LinkModal extends Component {
	state = {
		isModal: false,
		redirect: false,
	};

	toggleModal = (e) => {
		e.preventDefault();
		const toggleState = !this.state.isModal;
		this.setState({
			isModal: toggleState,
		});
	};

	chooseYes = () => {
		if (this.props.yesPath) {
			this.setState({
				redirect: true,
			});
		} else {
			this.toggleModal();
		}
	};

	render() {
		if (this.state.redirect) {
			return <Redirect push to={this.props.yesPath} />;
		}
		return (
			<div>
				<a href="#modal" onClick={this.toggleModal}>
					{this.props.linkText}
				</a>
				<Modal isOpen={this.state.isModal} toggle={this.toggleModal}>
					<ModalHeader toggle={this.toggleModal}>{this.props.title}</ModalHeader>
					<ModalBody>
						<p>{this.props.body}</p>
					</ModalBody>
					<ModalFooter style={modalFooterStyle}>
						<Button className="btn-danger" onClick={this.toggleModal}>
							No
						</Button>
						<Button className="btn-success" onClick={this.chooseYes}>
							Yes
						</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}

const modalFooterStyle = {
	display: 'flex',
	FlexDirection: 'row',
	justifyContent: 'space-between',
};

export default Radium(LinkModal);
